import { render, staticRenderFns } from "./NavMenuGroup.vue?vue&type=template&id=19d833ab&"
import script from "./NavMenuGroup.vue?vue&type=script&lang=js&"
export * from "./NavMenuGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports